<template>
  <div class="app-container">
    <el-card
      v-loading="loading"
      shadow="never"
      style="margin-bottom: 20px;"
    >
      <div
        class="description_text"
        style="margin-top:10px;margin-left:30px;"
      >
        <el-row :gutter="21">
          <el-col :span="3">
            <div class="term">结算费用：</div>
            <div class="detail">{{ statData.amount }}</div>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <div class="filter-container">
      <span
        v-permission="['HourCheck:HourCheck:Query']"
        class="filter-item"
      >项目名称</span>
      <el-input
        v-permission="['HourCheck:HourCheck:Query']"
        v-model="listQuery.projectName"
        placeholder="请输入项目名称"
        style="width: 200px;"
        class="filter-item"
        @keyup.enter.native="handleFilter"
      />
      <span
        v-permission="['HourCheck:HourCheck:Query']"
        class="filter-item"
      >姓名</span>
      <el-input
        v-permission="['HourCheck:HourCheck:Query']"
        v-model="listQuery.name"
        placeholder="请输入姓名"
        style="width: 200px;"
        class="filter-item"
        @keyup.enter.native="handleFilter"
      />
      <span
        v-permission="['HourCheck:HourCheck:Query']"
        class="filter-item"
      >结算月份</span>
      <el-date-picker
        v-model="listQuery.month"
        value-format="yyyy-MM"
        type="date"
        style="width: 200px;margin-left:5px;"
        placeholder="请选择结算月份"
      >

      </el-date-picker>
      <el-button
        v-permission="['HourCheck:HourCheck:Query']"
        v-waves
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
      >搜索</el-button>
      <el-button
        v-permission="['HourCheck:HourCheck:Add']"
        class="filter-item"
        style="margin-left: 10px;"
        type="primary"
        icon="el-icon-edit"
        @click="handleCreate"
      >添加</el-button>
      <br>
      <a
        class="el-button el-button--text"
        href="../../../小时工考勤模板.xlsx"
        target="_blank"
        download="小时工考勤模板.xlsx"
      >小时工考勤模板</a>
      <el-upload
        style="margin-left:10px;"
        class="filter-item"
        :action="action"
        :show-file-list="false"
        :on-success="handleExcelSuccess"
        :before-upload="beforeExcelUpload"
        :headers="uploadMode.headers"
      >
        <el-button type="primary">导入Excel</el-button>
      </el-upload>
    </div>

    <el-table
      :key="tableKey"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column
        label="项目名称"
        prop="projectName"
        align="center"
      />
      <el-table-column
        label="姓名"
        prop="name"
        align="center"
      />
      <el-table-column
        label="部门岗位"
        prop="dept"
        align="center"
      />
      <el-table-column
        label="考勤记录"
        align="center"
      >
        <el-table-column
          label="1"
          prop="day1"
          align="center"
        />
        <el-table-column
          label="2"
          prop="day2"
          align="center"
        />
        <el-table-column
          label="3"
          prop="day3"
          align="center"
        />
        <el-table-column
          label="4"
          prop="day4"
          align="center"
        />
        <el-table-column
          label="5"
          prop="day5"
          align="center"
        />
        <el-table-column
          label="6"
          prop="day6"
          align="center"
        />
        <el-table-column
          label="7"
          prop="day7"
          align="center"
        />
        <el-table-column
          label="8"
          prop="day8"
          align="center"
        />
        <el-table-column
          label="9"
          prop="day9"
          align="center"
        />
        <el-table-column
          label="10"
          prop="day10"
          align="center"
        />
        <el-table-column
          label="11"
          prop="day11"
          align="center"
        />
        <el-table-column
          label="12"
          prop="day12"
          align="center"
        />
        <el-table-column
          label="13"
          prop="day13"
          align="center"
        />
        <el-table-column
          label="14"
          prop="day14"
          align="center"
        />
        <el-table-column
          label="15"
          prop="day15"
          align="center"
        />
        <el-table-column
          label="16"
          prop="day16"
          align="center"
        />
        <el-table-column
          label="17"
          prop="day17"
          align="center"
        />
        <el-table-column
          label="18"
          prop="day18"
          align="center"
        />
        <el-table-column
          label="19"
          prop="day19"
          align="center"
        />
        <el-table-column
          label="20"
          prop="day20"
          align="center"
        />
        <el-table-column
          label="21"
          prop="day21"
          align="center"
        />
        <el-table-column
          label="22"
          prop="day22"
          align="center"
        />
        <el-table-column
          label="23"
          prop="day23"
          align="center"
        />
        <el-table-column
          label="24"
          prop="day24"
          align="center"
        />
        <el-table-column
          label="25"
          prop="day25"
          align="center"
        />
        <el-table-column
          label="26"
          prop="day26"
          align="center"
        />
        <el-table-column
          label="27"
          prop="day27"
          align="center"
        />
        <el-table-column
          label="28"
          prop="day28"
          align="center"
        />
        <el-table-column
          label="29"
          prop="day29"
          align="center"
        />
        <el-table-column
          label="30"
          prop="day30"
          align="center"
        />
        <el-table-column
          label="31"
          prop="day31"
          align="center"
        />
      </el-table-column>
      <el-table-column
        label="总工时"
        prop="totalHour"
        align="center"
      />
      <el-table-column
        label="单价(元/小时)"
        prop="price"
        align="center"
      />
      <el-table-column
        label="总金额"
        prop="totalAmount"
        align="center"
      />
      <el-table-column
        label="扣款项"
        align="center"
      >
        <el-table-column
          label="水电费"
          prop="waterAmount"
          align="center"
        />
        <el-table-column
          label="住宿费"
          prop="hotelAmount"
          align="center"
        />
        <el-table-column
          label="其他费用"
          prop="otherAmount"
          align="center"
        />
      </el-table-column>
      <el-table-column
        label="实际费用"
        prop="actualAmount"
        align="center"
      />
      <el-table-column
        label="备注"
        prop="remark"
        align="center"
      />
      <el-table-column
        label="结算月份"
        align="center"
      >
        <template slot-scope="{row}">
          <span>{{ row.month | parseTime('{y}-{m}') }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="300"
        class-name="small-padding fixed-width"
        fixed="right"
      >
        <template slot-scope="{row}">
          <el-button
            v-permission="['HourCheck:HourCheck:Update']"
            size="mini"
            type="primary"
            @click="handleUpdate(row)"
          >编辑</el-button>
          <el-button
            v-permission="['HourCheck:HourCheck:Del']"
            size="mini"
            type="danger"
            @click="handleDelete(row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />

    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        ref="dataForm"
        :inline="true"
        :rules="rules"
        :model="temp"
        label-position="left"
        label-width="110px"
      >
        <el-form-item
          label="项目名称"
          prop="projectName"
        >
          <el-input v-model="temp.projectName" />
        </el-form-item>
        <el-form-item
          label="姓名"
          prop="name"
        >
          <el-input v-model="temp.name" />
        </el-form-item>
        <el-form-item
          label="部门岗位"
          prop="dept"
        >
          <el-input v-model="temp.dept" />
        </el-form-item>
        <el-form-item
          label="总工时"
          prop="totalHour"
        >
          <el-input-number v-model="temp.totalHour" />
        </el-form-item>
        <el-form-item
          label="单价(元/小时)"
          prop="price"
        >
          <el-input-number v-model="temp.price" />
        </el-form-item>
        <el-form-item
          label="总金额"
          prop="totalAmount"
        >
          <el-input-number v-model="temp.totalAmount" />
        </el-form-item>
        <el-form-item
          label="水电费"
          prop="waterAmount"
        >
          <el-input-number v-model="temp.waterAmount" />
        </el-form-item>
        <el-form-item
          label="住宿费"
          prop="hotelAmount"
        >
          <el-input-number v-model="temp.hotelAmount" />
        </el-form-item>
        <el-form-item
          label="其他费用"
          prop="otherAmount"
        >
          <el-input-number v-model="temp.otherAmount" />
        </el-form-item>
        <el-form-item
          label="实际费用"
          prop="actualAmount"
        >
          <el-input-number v-model="temp.actualAmount" />
        </el-form-item>
        <el-form-item
          label="备注"
          prop="remark"
        >
          <el-input v-model="temp.remark" />
        </el-form-item>
        <el-form-item
          label="结算月份"
          prop="month"
        >
          <el-date-picker
            type="month"
            value-format="yyyy-MM"
            v-model="temp.month"
            placeholder="请选择结算月份"
          />
        </el-form-item>
        <el-form-item label="考勤记录">
          <el-row>
            <el-col :span="4">
              <span>1号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day1"
              />
            </el-col>
            <el-col :span="4">
              <span>2号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day2"
              />
            </el-col>
            <el-col :span="4">
              <span>3号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day3"
              />
            </el-col>
            <el-col :span="4">
              <span>4号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day4"
              />
            </el-col>
            <el-col :span="4">
              <span>5号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day5"
              />
            </el-col>
            <el-col :span="4">
              <span>6号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day6"
              />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <span>7号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day7"
              />
            </el-col>
            <el-col :span="4">
              <span>8号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day8"
              />
            </el-col>
            <el-col :span="4">
              <span>9号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day9"
              />
            </el-col>
            <el-col :span="4">
              <span>10号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day10"
              />
            </el-col>
            <el-col :span="4">
              <span>11号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day11"
              />
            </el-col>
            <el-col :span="4">
              <span>12号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day12"
              />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <span>13号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day13"
              />
            </el-col>
            <el-col :span="4">
              <span>14号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day14"
              />
            </el-col>
            <el-col :span="4">
              <span>15号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day15"
              />
            </el-col>
            <el-col :span="4">
              <span>16号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day16"
              />
            </el-col>
            <el-col :span="4">
              <span>17号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day17"
              />
            </el-col>
            <el-col :span="4">
              <span>18号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day18"
              />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <span>19号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day19"
              />
            </el-col>
            <el-col :span="4">
              <span>20号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day20"
              />
            </el-col>
            <el-col :span="4">
              <span>21号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day21"
              />
            </el-col>
            <el-col :span="4">
              <span>22号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day22"
              />
            </el-col>
            <el-col :span="4">
              <span>23号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day23"
              />
            </el-col>
            <el-col :span="4">
              <span>24号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day24"
              />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <span>25号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day25"
              />
            </el-col>
            <el-col :span="4">
              <span>26号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day26"
              />
            </el-col>
            <el-col :span="4">
              <span>27号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day27"
              />
            </el-col>
            <el-col :span="4">
              <span>28号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day28"
              />
            </el-col>
            <el-col :span="4">
              <span>29号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day29"
              />
            </el-col>
            <el-col :span="4">
              <span>30号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day30"
              />
            </el-col>
            <el-col :span="4">
              <span>31号：</span>
              <el-input
                style="width:100px;"
                v-model="temp.day31"
              />
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="dialogStatus==='create'?createData():updateData()"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import permission from '@/directive/permission/index.js' // 权限判断指令
import { create, delhourcheck, update, querypage } from '@/api/hourcheck'
import waves from '@/directive/waves' // waves directive
import Pagination from '@/components/Pagination' // secondary package based on el-pagination
import { parseTime } from '@/utils'

export default {
  name: 'hourcheck',
  components: { Pagination },
  directives: { waves, permission },
  filters: {
    parseTime: parseTime
  },
  data () {
    return {
      action: process.env.VUE_APP_BASE_API + '/api/v1/hourcheck/importexcel',
      daysNum: 31,
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        projectName: undefined,
        name: undefined,
        month: undefined,
        page: 1,
        limit: 20
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: 'Edit',
        create: 'Create'
      },
      statData: {//统计数据
        amount: 0,//结算费用统计
      },
      temp: {
        id: undefined,
        projectName: undefined,
        name: undefined,
        dept: undefined,
        totalHour: undefined,
        price: undefined,
        totalAmount: undefined,
        waterAmount: undefined,
        hotelAmount: undefined,
        otherAmount: undefined,
        actualAmount: undefined,
        remark: undefined,
        day1: 0,
        day2: 0,
        day3: 0,
        day4: 0,
        day5: 0,
        day6: 0,
        day7: 0,
        day8: 0,
        day9: 0,
        day10: 0,
        day11: 0,
        day12: 0,
        day13: 0,
        day14: 0,
        day15: 0,
        day16: 0,
        day17: 0,
        day18: 0,
        day19: 0,
        day20: 0,
        day21: 0,
        day22: 0,
        day23: 0,
        day24: 0,
        day25: 0,
        day26: 0,
        day27: 0,
        day28: 0,
        day29: 0,
        day30: 0,
        day31: 0,
        month: undefined,
      },
      rules: {
        projectName: [

          {
            required: true,
            message: '项目名称是必填项',
            trigger: 'blur'
          },

          {
            max: 50,
            message: '项目名称最大长度50个字符',
            trigger: 'blur'
          },
        ],
        name: [

          {
            required: true,
            message: '姓名是必填项',
            trigger: 'blur'
          },

          {
            max: 10,
            message: '姓名最大长度10个字符',
            trigger: 'blur'
          },
        ],
        dept: [

          {
            required: true,
            message: '部门岗位是必填项',
            trigger: 'blur'
          },

          {
            max: 10,
            message: '部门岗位最大长度10个字符',
            trigger: 'blur'
          },
        ],
        totalHour: [

          {
            required: true,
            message: '总工时是必填项',
            trigger: 'blur'
          },
        ],
        price: [

          {
            required: true,
            message: '单价(元/小时)是必填项',
            trigger: 'blur'
          },
        ],
        totalAmount: [

          {
            required: true,
            message: '总金额是必填项',
            trigger: 'blur'
          },
        ],
        waterAmount: [

          {
            required: true,
            message: '水电费是必填项',
            trigger: 'blur'
          },
        ],
        hotelAmount: [

          {
            required: true,
            message: '住宿费是必填项',
            trigger: 'blur'
          },
        ],
        otherAmount: [

          {
            required: true,
            message: '其他费用是必填项',
            trigger: 'blur'
          },
        ],
        actualAmount: [

          {
            required: true,
            message: '实际费用是必填项',
            trigger: 'blur'
          },
        ],
        remark: [

          {
            max: 1000,
            message: '备注最大长度1000个字符',
            trigger: 'blur'
          },
        ],
        month: [

          {
            required: true,
            message: '结算月份是必填项',
            trigger: 'blur'
          },
        ],
      }
    }
  },
  created () {
    this.getList()
    this.setInitDays()
  },
  methods: {
    getList () {
      this.listLoading = true
      querypage(this.listQuery).then(response => {
        this.list = response.items
        this.total = response.totalCount
        this.statData.amount = response.amount
        this.listLoading = false
      })
    },
    handleFilter () {
      this.listQuery.page = 1
      this.getList()
    },
    resetTemp () {
      this.temp = {
        projectName: undefined,
        name: undefined,
        dept: undefined,
        totalHour: undefined,
        price: undefined,
        totalAmount: undefined,
        waterAmount: undefined,
        hotelAmount: undefined,
        otherAmount: undefined,
        actualAmount: undefined,
        remark: undefined,
        days: undefined,
        month: undefined,
      }
    },
    handleCreate () {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData () {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          create(this.temp).then(() => {
            this.handleFilter()
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    handleUpdate (row) {
      this.temp = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData () {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          const tempData = Object.assign({}, this.temp)
          update(tempData).then(() => {
            for (const v of this.list) {
              if (v.id === this.temp.id) {
                const index = this.list.indexOf(v)
                this.list.splice(index, 1, this.temp)
                break
              }
            }
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    handleExcelSuccess (res, file) {
      this.handleFilter()
      if (res.msg !== '上传成功!') {
        this.$message.error(res.msg)
      } else {
        this.$message.success(res.msg)
      }
    },
    handleDelete (row) {
      this.$confirm(`确定删除编号为${row.id}的数据吗?`, '操作提示', {})
        .then(() => {
          delhourcheck(row.id).then(() => {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success',
              duration: 2000
            })
            const index = this.list.indexOf(row)
            this.list.splice(index, 1)
          })
        })
        .catch(() => {
          this.$notify({
            title: '取消',
            message: '已取消删除',
            type: 'info',
            duration: 2000
          })
        })
    },
  }
}
</script>
<style>
.term {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  padding-bottom: 16px;
  margin-right: 8px;
  white-space: nowrap;
  display: table-cell;
}
.detail {
  font-size: 14px;
  line-height: 1.5;
  width: 100%;
  padding-bottom: 16px;
  color: rgba(0, 0, 0, 0.65);
  display: table-cell;
}
</style>
